import { Col, Row, Typography } from 'antd'

export function CardHeader({
  children,
  level = 4,
  style = {},
  innerRef = null,
  extra = null,
}) {
  return (
    <Row justify="space-between">
      <Col>
        <Typography.Title
          ref={innerRef}
          level={level}
          style={{ paddingInline: 16, ...style }}
        >
          {children}
        </Typography.Title>
      </Col>
      {extra && <Col>{extra}</Col>}
    </Row>
  )
}
